import React, { useState, useEffect } from "react";

import {
  FaChevronDown,
  FaChevronRight,
  FaCheck,
  FaTimes,
} from "react-icons/fa";

const SeedCheckComponent = () => {
  const [seedData, setSeedData] = useState(0);
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`https://grintoolsapi.revcore.net/seedcheck/latest`).then(
      (response) =>
        response.json().then((resultData) => {
          setSeedData(resultData);
          setLoading(false);
          console.dir(seedData);
        })
    );
  }, []);

  if (isLoading) {
    return (
      <section
        className="has-background-white has-text-white"
        style={{ padding_bottom: "140px" }}
      >
        <div className="section pb-2 has-background-dark">
          <div className="container is-relative mb-5">
            <h2 className="is-2">Fetching latest seed report data...</h2>
          </div>
        </div>
      </section>
    );
  }

  const dateString = new Date(Date.parse(seedData.created_at + "Z")).toUTCString().replace('GMT', 'UTC');

  return (
    <section
      className="has-background-white has-text-white"
      style={{ padding_bottom: "140px" }}
    >
      <div className="section pb-2 has-background-dark">
        <div className="container is-relative mb-5">
          <h3 className="title has-text-white is-2">
            Grin DNS Seed Node Check
          </h3>
          <h6 className="title has-text-white is-6">
            As of {dateString}
          </h6>
          <h2 className="title has-text-white">Mainnet</h2>
          <SeedResultsDisplay resultSet={seedData.results.mainnet} />
          <h2 className="title has-text-white">Testnet</h2>
          <SeedResultsDisplay resultSet={seedData.results.testnet} />
        </div>
      </div>
    </section>
  );
};

const SeedResultsDisplay = (props) => {
  const [rowsExpanded, updateRowsExpanded] = useState(
    new Array(props.resultSet.length).fill(false)
  );

  const rowToggle = (e, index) => {
    e.preventDefault();
    const updatedRows = [...rowsExpanded];
    updatedRows[index] = !updatedRows[index];
    updateRowsExpanded(updatedRows);
  };

  return (
    <table className="table is-fullwidth">
      <thead>
        <tr>
          <th className="is-chevron-cell"></th>
          <th>
            <abbr title="Seed URL">Seed</abbr>
          </th>
          <th>
            <abbr title="DNS Resolutions Found URL">DNS Resolves</abbr>
          </th>
          <th>
            <abbr title="Node Running">Peers Can Connect</abbr>
          </th>
          <th>
            <abbr title="Version">Version</abbr>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.resultSet.map((result, index) => {
          return (
            <>
              <tr
                key={`${result.url}_${index}`}
                role="button"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  rowToggle(e, index);
                }}
              >
                <td className="is-chevron-cell">
                  <a
                    role="button"
                    onClick={(e) => {
                      rowToggle(e, index);
                    }}
                  >
                    <span className="icon is-expanded">
                      {(() => {
                        switch (rowsExpanded[index]) {
                          case true:
                            return <FaChevronDown size="20" color="white" />;
                          case false:
                            return <FaChevronRight size="20" color="white" />;
                        }
                      })()}
                    </span>
                  </a>
                </td>
                <td>{result.url}</td>
                <td>
                      {(() => {
                        switch (result.dns_resolutions_found) {
                          case true:
                            return <FaCheck size="20" color="green" />;
                          case false:
                            return <FaTimes size="20" color="red" />;
                        }
                      })()}
                </td>
                {(() => {
                  switch (result.success) {
                    case true:
                      return (
                        <>
                          <td>
                            <FaCheck size="20" color="green" />
                          </td>
                          <td>{result.successful_attempts[0].user_agent}</td>
                        </>
                      );
                    case false:
                      return (
                        <>
                          <td>
                            <FaTimes size="20" color="red" />
                          </td>
                          <td>N/A</td>
                        </>
                      );
                  }
                })()}
              </tr>
              <tr
                className={`detail ${rowsExpanded[index] ? "" : "is-hidden"}`}
              >
                <td colSpan="5">
                  <div
                    className={`section py-1 my-1 ${
                      result.successful_attempts.length === 0 ? "is-hidden" : ""
                    }`}
                  >
                    <h5 className="title has-text-success is-5 my-2 mx-0">
                      Successful Handshake Attempts
                    </h5>
                    <table className="table mb-1">
                      <tbody>
                        {result.successful_attempts.map((attempt, s_index) => {
                          return (
                            <tr key={`${attempt.ip_addr}_${s_index}`}>
                              <td>{attempt.ip_addr}</td>
                              <td>{attempt.user_agent}</td>
                              <td>{attempt.capabilities}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div
                    className={`section py-1 my-1 ${
                      result.unsuccessful_attempts.length === 0
                        ? "is-hidden"
                        : ""
                    }`}
                  >
                    <h5 className="title has-text-danger is-5 my-2 ">
                      Unsuccessful Handshake Attempts
                    </h5>
                    <table className="table">
                      <tbody>
                        {result.unsuccessful_attempts.map(
                          (attempt, us_index) => {
                            return (
                              <tr key={`${attempt.ip_addr}_${us_index}`}>
                                <td>{attempt.ip_addr}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </>
          );
        })}
      </tbody>
    </table>
  );
};

export default SeedCheckComponent;
